import { ChatTaskEventObject, ChatTaskEventType } from '@scale/shared/types/chat/events';
import { Event, logEvent } from 'react-scale/lib/events';
import { BaseEvents } from './eventMap';
import { EventBus } from '../utils/eventBus';
import { useContext, createContext } from 'react';

export const logChatTaskEvent = async (event: ChatTaskEventObject<ChatTaskEventType>) => {
  await logEvent(Event.ChatTask, event);
};

export type ChatEventBus = EventBus<BaseEvents>;

export function createEventBus(): ChatEventBus {
  return new EventBus<BaseEvents>();
}

export const EventBusContext = createContext<ChatEventBus>(createEventBus());

export function useEventBus() {
  return useContext(EventBusContext);
}
